module.exports = __webpack_public_path__ + "static/media/print6.e6056ba3.jpg";